export default __webpack_public_path__ + "static/media/saadi.ffdb6727.jpg";